import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { Location } from '@angular/common';

import { BaseModalPageComponent } from '../../base-modal.component';
import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';
import { ParticipantsPluginService } from '../participants/participants-plugin.service';
import { ActionParticipantsPluginService } from './actionparticipants-plugin.service';
import { InspectionService } from '../../shared/services';
import { InspectionPlugin } from '../../shared/models';

import { v4 as uuid } from 'uuid';
import * as _ from 'lodash';

@Component({
    selector: 'actionparticipants-edit',
    templateUrl: './actionparticipants-edit.component.html',
    standalone: false
})
export class ActionParticipantsEditPageComponent extends BaseModalPageComponent implements OnInit {
  public actionPlanId: string;
  public actionPlanItemId: string;
  pluginId: string;
  public plugin: any;
  public participants = [];
  public participant: any = {};
  public processing = false;
  private inspectionId: string;
  private inspectionPlugin: InspectionPlugin;
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;
  @ViewChild('participantsModal', { static: true })
  participantsModal: ModalComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: ActionParticipantsPluginService,
    private participantsService: ParticipantsPluginService,
    private inspectionService: InspectionService,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['actionPlanId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.actionPlanId = id;

      const actionPlanItemId = params['actionPlanItemId'];
      if (actionPlanItemId == null) this.router.navigate([this.inspectionsRoute, this.actionPlanId]);

      this.actionPlanItemId = actionPlanItemId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  add() {
    if (!this.participant.Name || !this.inspectionPlugin || !this.inspectionPlugin) return;

    this.participant.Id = uuid();
    this.participant.label = `${this.participant.Name} : ${this.participant.Function}`;
    this.participants.push(this.participant);
    this.participant = {};
    this.sort();
    this.participantsService
      .updateParticipants(this.inspectionId, this.inspectionPlugin.id, this.participants)
      .subscribe();
  }

  sort() {
    this.participants = this.participants
      .filter((p) => p.Name)
      .sort((a, b) => {
        const nameA = a.Name.toUpperCase();
        const nameB = b.Name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        } else if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
  }

  save() {
    const participants = this.participants.filter((p) => p.selected).map((p) => p.Id);
    this.processing = true;
    this.service
      .updateParticipants(this.actionPlanId, this.actionPlanItemId, this.pluginId, participants)
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
      });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.actionPlanId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.inspectionId = this.plugin.actionPlan.inspectionId;
      if (!this.inspectionId) {
        return;
      }
      this.inspectionService.getInspection(this.inspectionId).subscribe((inspection) => {
        if (!inspection || !inspection.allPlugins) {
          return;
        }
        this.inspectionPlugin = inspection.allPlugins.find((p) => p.pluginType === 'participants');

        if (!this.inspectionPlugin || !this.inspectionPlugin.config.Participants) {
          return;
        }
        this.participants = this.inspectionPlugin.config.Participants;
        this.sort();
        this.participants.forEach((p) => {
          p.selected = this.plugin.config.Participants.includes(p.Id);
          p.label = `${p.Name} : ${p.Function}`;
        });
      });
      this.cdRef.detectChanges();
    });
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      default:
    }
  }

  openParticipantsSelector() {
    this.openMultipleSelector(this.participantsModal, this.participants, true);
  }

  getSelectedValues() {
    const defaultValue = 'Select a participant';
    const selectedValues = this.participants.filter((p) => p.selected).map((p) => p.label);
    return selectedValues.length > 0 ? selectedValues.join('<br/>') : defaultValue;
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.actionPlanId, this.actionPlanItemId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }

  selectParticipants(e: any) {}
}
